module.exports = __webpack_public_path__ + "static/media/mapping_success.35c3802a.svg";